import { Component, EventEmitter, OnInit, Output, inject } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';
import { Order } from '@compumark/order-management-client';
import { range } from 'lodash';

import { ClassValidator } from '../../chips/validator/class-validator';
import { sanitizeInput } from '../../shared/sanitize.util';
import { UpdateOrderModel } from '../models/update-order-model';

@Component({
  selector: 'app-product-brand-info',
  templateUrl: './product-brand-info.component.html',
  styleUrls: ['./product-brand-info.component.scss'],
  standalone: false,
})
export class ProductBrandInfoComponent implements OnInit {
  data = inject<{
    model: UpdateOrderModel;
  }>(MAT_DIALOG_DATA);
  private fb = inject(FormBuilder);

  public order: Order;
  public productBrandForm!: FormGroup;
  public customClassesValidatorFun = ClassValidator.classesValidator;
  public textAreaMaxlength = 4000;
  public textAreaMinRow = 3;
  public textAreaMaxRow = 10;
  public readonly MOBILE_APP_WATCH = 'Mobile App Watch';
  public toolTipMessage = $localize`:@@ProductBrandInfoGoodsAndServicesTooltip:This information is used to improve your review of watch results by enhancing the Opposition Score and Goods Similarity ranking.`;

  @Output() notifyProductFormValidation = new EventEmitter();
  constructor() {
    this.order = this.data.model.order!;
  }

  ngOnInit(): void {
    this.productBrandForm = this.fb.group({
      classesControl: this.fb.control('', []),
      goodsAndServicesControl: [this.order.goodsAndServices!],
    });

    this.changeOrderModel();
  }

  remainingCharacters(value: string): number {
    return this.textAreaMaxlength - value.length;
  }

  private changeOrderModel = () => {
    this.productBrandForm
      .get('goodsAndServicesControl')
      ?.valueChanges.subscribe(
        (value) => (this.order.goodsAndServices = sanitizeInput(value) as any),
      );

    this.productBrandForm.get('classesControl')?.valueChanges.subscribe(() => {
      this.notifyProductFormValidation.emit(
        this.productBrandForm.get('classesControl')?.valid,
      );
      this.sortClasses();
    });
  };

  sanitizeField(controlName: string): void {
    const control = this.productBrandForm.get(controlName);
    if (!control) {
      return;
    }
    const sanitized = sanitizeInput(control.value ?? '');
    if (sanitized !== control.value) {
      control.setValue(sanitized, { emitEvent: false });
    }
  }

  get classes(): string[] {
    return this.order.classes!;
  }

  get productName(): string {
    return this.order.productName!;
  }

  formatData(value: string): string[] {
    const chips: string[] = [];
    const match: RegExpExecArray | null =
      ClassValidator.rangePattern.exec(value);
    if (match) {
      const rangeNumberArray = range(Number(match[1]), Number(match[2]) + 1);
      chips.push(...rangeNumberArray.map((o) => o.toString()));
    } else {
      chips.push(value.replace(ClassValidator.leadingZerosPattern, ''));
    }
    return chips;
  }

  sortClasses = () => {
    this.order.classes?.sort((firstClass, nextClass) => {
      return parseFloat(firstClass) - parseFloat(nextClass);
    });
  };
}
